import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';

export default function SuchePage() {
  const [q, setQ] = useState('');
  const [artikel, setArtikel] = useState([]);
  const [behaelter, setBehaelter] = useState([]);
  const [laden, setLaden] = useState(false);
  const navigate = useNavigate();
  const timerRef = useRef(null);

  const ergebnisse = artikel.length + behaelter.length;

  async function suchen(val) {
    if (val.length < 2) { setArtikel([]); setBehaelter([]); return; }
    setLaden(true);
    try {
      const r = await api.get(`/suche?q=${encodeURIComponent(val)}`);
      setArtikel(r.data.artikel || []);
      setBehaelter(r.data.behaelter || []);
    } catch {}
    setLaden(false);
  }

  function handleChange(e) {
    const val = e.target.value;
    setQ(val);
    clearTimeout(timerRef.current);
    if (val.length < 2) { setArtikel([]); setBehaelter([]); return; }
    timerRef.current = setTimeout(() => suchen(val), 300);
  }

  return (
    <div>
      <h1 style={{ margin: '0 0 4px', fontSize: '22px', fontWeight: '700' }}>🔍 Suchen</h1>
      <p style={{ color: '#64748b', fontSize: '13px', marginTop: '0', marginBottom: '12px' }}>Artikel, Kisten, Barcodes – alles auf einmal.</p>
      <div style={{ position: 'relative', marginBottom: '16px' }}>
        <input value={q} onChange={handleChange}
          placeholder="Name, Barcode, Kategorie oder Kiste..."
          aria-label="Suchen"
          style={{ width: '100%', padding: '14px 16px', paddingRight: q ? '48px' : '16px', borderRadius: '12px', border: '2px solid #e2e8f0', fontSize: '15px', boxSizing: 'border-box', outline: 'none' }}
          autoFocus />
        {q && (
          <button onClick={() => { setQ(''); setArtikel([]); setBehaelter([]); }} aria-label="Suche löschen"
            style={{ position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)', background: '#e2e8f0', border: 'none', borderRadius: '50%', width: '24px', height: '24px', cursor: 'pointer', fontSize: '14px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#64748b' }}>
            ×
          </button>
        )}
      </div>

      {laden && <div style={{ textAlign: 'center', color: '#94a3b8' }}>⏳ Suche...</div>}

      {q.length === 0 && (
        <div style={{ textAlign: 'center', padding: '40px', color: '#94a3b8' }}>
          <div style={{ fontSize: '48px' }}>🔍</div>
          <div style={{ marginTop: '12px', fontWeight: '600', color: '#64748b' }}>Was suchst du?</div>
          <div style={{ marginTop: '6px', fontSize: '13px' }}>Suchbegriff eingeben – Artikel und Kisten werden gefunden</div>
        </div>
      )}

      {q.length > 0 && q.length < 2 && (
        <div style={{ textAlign: 'center', color: '#94a3b8', fontSize: '13px', padding: '20px' }}>Mindestens 2 Zeichen eingeben</div>
      )}

      {q.length >= 2 && !laden && ergebnisse === 0 && (
        <div style={{ textAlign: 'center', padding: '40px 20px', color: '#94a3b8' }}>
          <div style={{ fontSize: '48px' }}>🔍</div>
          <div style={{ marginTop: '12px', fontWeight: '600', fontSize: '15px', color: '#64748b' }}>Kein Artikel gefunden für „{q}"</div>
          <div style={{ fontSize: '13px', marginTop: '6px', marginBottom: '16px' }}>Möchtest du diesen Artikel neu einlagern?</div>
          <button onClick={() => navigate('/behaelter')}
            style={{ padding: '10px 20px', background: '#f59e0b', color: 'white', border: 'none', borderRadius: '10px', cursor: 'pointer', fontWeight: '700' }}>
            Zu den Kisten → Artikel anlegen
          </button>
        </div>
      )}

      {behaelter.length > 0 && (
        <div style={{ marginBottom: '20px' }}>
          <div style={{ fontWeight: '700', fontSize: '11px', color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.8px', marginBottom: '8px' }}>
            KISTEN ({behaelter.length})
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            {behaelter.map(b => (
              <div key={b.id} onClick={() => navigate(`/behaelter/${b.id}`)}
                style={{ background: 'white', borderRadius: '12px', padding: '14px 16px', boxShadow: '0 1px 4px rgba(0,0,0,0.06)', cursor: 'pointer', borderLeft: `4px solid ${b.farbe || '#f59e0b'}`, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div>
                  <div style={{ fontWeight: '700', fontSize: '15px' }}>📦 {b.name}</div>
                  {b.beschreibung && <div style={{ color: '#64748b', fontSize: '12px', marginTop: '2px' }}>{b.beschreibung}</div>}
                  <div style={{ display: 'flex', gap: '8px', marginTop: '6px', flexWrap: 'wrap' }}>
                    {b.standort_name && <span style={{ background: '#f1f5f9', color: '#64748b', padding: '2px 8px', borderRadius: '99px', fontSize: '11px' }}>{b.standort_icon} {b.standort_name}</span>}
                    <span style={{ background: '#fef3c7', color: '#92400e', padding: '2px 8px', borderRadius: '99px', fontSize: '11px' }}>📋 {b.artikel_anzahl || 0} Artikel</span>
                  </div>
                </div>
                <span style={{ fontSize: '20px', color: '#94a3b8' }}>›</span>
              </div>
            ))}
          </div>
        </div>
      )}

      {artikel.length > 0 && (
        <div>
          <div style={{ fontWeight: '700', fontSize: '11px', color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.8px', marginBottom: '8px' }}>
            ARTIKEL ({artikel.length})
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            {artikel.map(e => (
              <div key={e.id} onClick={() => navigate(`/behaelter/${e.behaelter_id}`)}
                style={{ background: 'white', borderRadius: '12px', padding: '14px 16px', boxShadow: '0 1px 4px rgba(0,0,0,0.06)', cursor: 'pointer', borderLeft: `4px solid ${e.behaelter_farbe || '#f59e0b'}` }}>
                <div style={{ fontWeight: '700', fontSize: '15px' }}>{e.name}</div>
                {e.beschreibung && <div style={{ color: '#64748b', fontSize: '12px', marginTop: '2px' }}>{e.beschreibung}</div>}
                <div style={{ display: 'flex', gap: '8px', marginTop: '6px', flexWrap: 'wrap' }}>
                  <span style={{ background: '#fef3c7', color: '#92400e', padding: '2px 8px', borderRadius: '99px', fontSize: '11px', fontWeight: '600' }}>📦 {e.behaelter_name}</span>
                  {e.standort_name && <span style={{ background: '#f1f5f9', color: '#64748b', padding: '2px 8px', borderRadius: '99px', fontSize: '11px' }}>{e.standort_icon} {e.standort_name}</span>}
                  {e.kategorie && <span style={{ background: '#eef2ff', color: '#6366f1', padding: '2px 8px', borderRadius: '99px', fontSize: '11px' }}>{e.kategorie}</span>}
                  <span style={{ background: '#f1f5f9', color: '#64748b', padding: '2px 8px', borderRadius: '99px', fontSize: '11px' }}>{e.menge} {e.einheit}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
